/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PostFacebookAccountByUserUuidReqBodyDto
 */
export interface PostFacebookAccountByUserUuidReqBodyDto {
    /**
     * 계정 아이디
     * @type {string}
     * @memberof PostFacebookAccountByUserUuidReqBodyDto
     */
    'id': string;
    /**
     * 계정 비밀번호
     * @type {string}
     * @memberof PostFacebookAccountByUserUuidReqBodyDto
     */
    'password': string;
    /**
     * 2단계 인증 방법
     * @type {string}
     * @memberof PostFacebookAccountByUserUuidReqBodyDto
     */
    'twoFactorMethodType'?: PostFacebookAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum;
    /**
     * 2단계 인증 코드
     * @type {string}
     * @memberof PostFacebookAccountByUserUuidReqBodyDto
     */
    'twoFactorCode'?: string;
}

export const PostFacebookAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum = {
    Email: 'email',
    Whatsapp: 'whatsapp'
} as const;

export type PostFacebookAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum = typeof PostFacebookAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum[keyof typeof PostFacebookAccountByUserUuidReqBodyDtoTwoFactorMethodTypeEnum];


